<template>
  <div class="codeManger">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">

        <el-input v-if="radio == '条件查询'" placeholder="请输入激活码查询" v-model="merInputVal" size="medium" style="width: 310px"
          class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>

        </el-input>
        <el-checkbox v-model="checked">模糊</el-checkbox>
        <div class="state">
          <el-radio-group v-model="state" class="x-m-l-10">
            <el-radio label="全部">全部</el-radio>
            <el-radio label="未使用">未使用</el-radio>
            <el-radio label="已绑定">已绑定</el-radio>
            <!-- <el-radio label="未激活">未激活</el-radio> -->
            <el-radio label="已激活">已激活</el-radio>
            <el-radio label="已过期">已过期</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="x-flex">
        <el-button v-if="showXz" type="" size="medium" @click="fRegWxUser('新增')">新增</el-button>
        <el-button v-if="showHb" type="" size="medium" @click="fRegWxUser('批量划拨')">批量划拨</el-button>
        <el-button v-if="showXg" type="" size="medium" @click="fRegWxUser('批量修改')">批量修改</el-button>
        <el-button v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'" type="" size="medium"
          @click="fRegWxUser('批量删除')">批量删除</el-button>
        <el-button v-if="showXz" type="primary" size="medium" @click="fRegWxUser('批量新增')">批量新增</el-button>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table ref="codeMangerTable" border resizable highlight-hover-row height="100%" :data="tableData"
          :sort-config="{remote:true}" @sort-change='fSort' :checkbox-config="{ reserve: true }" align="center">
          <vxe-column type="checkbox" fixed="left" width="60"></vxe-column>
          <vxe-column field="RC" title="序号" width="80" fixed="left" sortable></vxe-column>
          <vxe-column field="pro_add_day" title="产品版本" width="100" sortable>
            <template slot-scope="scope">
              <span v-if="scope.row.pro_add_day == '365'">年版</span>
              <span v-else-if="scope.row.pro_add_day == '36500'">终身版</span>
              <span v-else>{{scope.row.pro_add_day}}</span>
            </template>
          </vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :width="item.width" v-for="item in tableJson" sortable
            :key="item.id">

          </vxe-column>

          <vxe-column fixed="right" title="操作" width="80" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <div class="x-flex x-row-around" v-if="scope.row.state != '已激活' && scope.row.state != '已过期'">
                <el-button v-if="scope.row.state != '已绑定' && showXg" type="text" size="mini" @click="fModify(scope.row)"
                  class="" style="color: #2c8ff2">
                  修改
                </el-button>
                <el-button v-if="scope.row.state != '未使用'" type="text" size="mini" @click="fRegWxUser('激活',scope.row)"
                  style="color: #2c8ff2">
                  激活
                </el-button>
              </div>
              <el-button v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'" type="text" size="mini" @click="fDel('DEL',scope.row.pro_code)"
                class="" style="color: #2c8ff2">
                删除
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
          :page-size="50" :current-page="nowPage" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="addOrEditPop" width="600px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">
          <!-- {{ codeMangerAddOrEdit == "PLADD" ? "批量生成" : "修改商户" }} -->
          {{codeMangerAddOrEdit}}
        </div>
        <div style="cursor: pointer;" @click="fClose()">
          X
        </div>
      </div>

      <!-- 机构编号  AI编码-->
      <div v-if="codeMangerAddOrEdit == '批量划拨'">
        <div class="x-flex x-p-b-20 x-p-t-20">
          所属机构：{{bykApi.global.fGetPlatform().partnerInfo.data.comp_name}}
        </div>
        <div class="x-flex x-p-b-20 ">
          <div class="x-w80">划拨给</div>
          <el-select class="x-w100p" v-model="codeInfo.pro_org_id" placeholder="服务商名称" filterable remote
            :remote-method='fQuerySearchOrg' @focus="fQuerySearchOrg('')" @change="">
            <el-option v-for="item in orgListSub" :key="item.RC" :label="item.comp_name" :value="item.user_phone">
              <span style="float: left">{{ item.comp_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.user_phone }}</span>
            </el-option>
          </el-select>
        </div>
        <div>
          本次划拨激活码数量：{{codeInfo.pro_code_arr.length}}个
        </div>
      </div>
      <div v-else-if="codeMangerAddOrEdit == '激活'">
        <div class="x-flex x-p-t-30 x-p-b-20 ">
          <div class="x-p-r-10 x-text-r must x-w100">
            手机号码
          </div>
          <div class="x-flex-1">
            <el-input v-model="codeInfo.mch_id"></el-input>
          </div>
          <div class="x-p-r-10 x-text-r must x-w100">
            门店编码
          </div>
          <div class="x-flex-1">
            <el-input v-model="codeInfo.mall_id"></el-input>
          </div>
        </div>
        <div style="padding-left: 34px;">
          本次延期天数：{{ codeInfo.pro_add_day  }}天
        </div>
        <div style="padding-left: 34px;">
          产品版本：{{ codeInfo.pro_add_day == 365?'年版':'终身版'  }}
        </div>
      </div>
      <div v-else>
        <div class="x-flex x-p-t-20 x-p-r-20">
          <div class="x-p-r-10 x-text-r must x-w100">
            生成类型
          </div>
          <div class="x-flex-1">
            <el-select v-model="codeInfo.pro_type" placeholder="请选择" class="x-w100p" size="medium" :disabled="true">
              <el-option v-for="item in proTypeOption" :key="item.val" :label="item.lable" :value="item.val">
              </el-option>
            </el-select>
          </div>
          <div class="x-p-r-10 x-text-r must x-w100" v-if="codeMangerAddOrEdit == '批量新增'">
            生成数量
          </div>
          <div class="x-flex-1" v-if="codeMangerAddOrEdit == '批量新增'">
            <el-input v-model="codeInfo.add_num"></el-input>
          </div>
          <div class="x-p-r-10 x-text-r x-w100" v-if="codeMangerAddOrEdit == '批量修改'">
            修改数量
          </div>
          <div class="x-flex-1" v-if="codeMangerAddOrEdit == '批量修改'">
            ：{{codeInfo.pro_code_arr.length}}
          </div>
          <div class="x-p-r-10 x-text-r x-w100" v-if="codeMangerAddOrEdit == '修改'">
            激活码
          </div>
          <div class="x-flex-1" v-if="codeMangerAddOrEdit == '修改'">
            <el-input v-model="codeInfo.pro_code" disabled></el-input>
          </div>

        </div>
        <div class="x-flex x-p-t-20 x-p-r-20">
          <div class="x-p-r-10 x-text-r must x-w100">
            售卖价格
          </div>
          <div class="x-flex-1">
            <el-input v-model="codeInfo.sale_money"></el-input>
          </div>
          <div class="x-p-r-10 x-text-r must x-w100">
            失效时间
          </div>
          <div class="x-flex-1">
            <el-date-picker style="width: 100%;" v-model="codeInfo.stop_time" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
        <div class="x-flex x-p-t-20 x-p-r-20">
          <div class="x-p-r-10 x-text-r must x-w100" style="white-space: nowrap;">
            次年续费
          </div>
          <div class=" x-w160">
            <el-input v-model="codeInfo.pro_sale_money"></el-input>
          </div>
          <!-- <div class="x-p-r-10 x-text-r must x-w100" style="white-space: nowrap;">
            产品到期
          </div>
          <div class="x-flex-1">
            <el-date-picker style="width: 100%;" v-model="codeInfo.pro_stop_time" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="pickerOptions">
            </el-date-picker>
          </div> -->
          <el-radio-group v-model="codeInfo.pro_add_day" class="x-m-l-10 x-p-l-20">
            <el-radio label="365">年版</el-radio>
            <el-radio label="36500">终身版</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="x-flex x-row-right x-p-t-30">
        <el-button type="info" size="small" v-if="codeMangerAddOrEdit == '修改'" @click="fDel('DEL')">删除</el-button>
        <el-button type="info" size="small" v-else @click="fClose">关闭</el-button>
        <el-button type="primary" size="small" @click="fSavecodeManger">保存</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showXz: false,
        showXg: false,
        showHb: false,
        radio: "条件查询",
        merInputVal: "",
        // uploadImgValue:'',//上传的文件名称
        checked: true, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        fileLise: [], //上传文件列表
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        state: '全部',
        orgListSub: [],
        proTypeOption: [{
          lable: 'SAAS',
          val: 'SAAS'
        }],
        tableJson: [{
            title: "状态",
            width: "80",
            sortType: "state",
          }, {
            title: "产品类型",
            width: "100",
            sortType: "pro_type",
          },
          {
            title: "激活码",
            width: "160",
            sortType: "pro_code",
          },
          {
            title: "失效时间",
            width: "170",
            sortType: "stop_time",
          }, {

            title: "售卖价格",
            width: "100",
            sortType: "sale_money",
          }, {

            title: "次年续费",
            width: "100",
            sortType: "pro_sale_money",
          },
          {
            title: "绑定服务商",
            width: "160",
            sortType: "pro_org_name",
          },
          // {
          //   title: "绑定时间",
          //   width: "200",
          //   sortType: "",
          // },
          {
            title: "激活商户",
            width: "200",
            sortType: "mch_id",
          },
          {
            title: "商户名",
            width: "200",
            sortType: "mch_name",
          },
          {
            title: "激活门店",
            width: "100",
            sortType: "store_id",
          },
          {
            title: "门店名",
            width: "180",
            sortType: "store_name",
          },
          // {
          //   title: "地址",
          //   width: "180",
          //   sortType: "chg_time",
          // },
          {
            title: "修改时间",
            width: "180",
            sortType: "chg_time",
          },
          {
            title: "生成批号",
            width: "180",
            sortType: "create_time",
          },
          {
            title: "所属服务商",
            width: "180",
            sortType: "org_name",
          },

        ],
        addOrEditPop: false, // 增加/修改用户
        codeMangerAddOrEdit: "批量新增",
        codeInfo: {
          pro_type: 'SAAS',
          pro_code: '',
          stop_time: this.bykApi.timeHelper.manyDaysLater(365),
          sale_money: '0',
          pro_sale_money: '299',
          pro_add_day: '365',
          addNum: '年版',
          // pro_stop_time: this.bykApi.timeHelper.manyDaysLater(365),
          add_num: '1',
          pro_code_arr: '',
          pro_org_id: '',
          remarks: '',
        },
        stateOption: [{
            label: '未绑定'
          },
          {
            label: '已绑定'
          },
          {
            label: '已解绑'
          },
        ],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          },
          shortcuts: [{
              text: '7天',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                picker.$emit('pick', date);
              }
            }, {
              text: '15天',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 15);
                picker.$emit('pick', date);
              }
            }, {
              text: '30天',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                picker.$emit('pick', date);
              }
            }, {
              text: '90天',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
                picker.$emit('pick', date);
              }
            }, {
              text: '180天',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 180);
                picker.$emit('pick', date);
              }
            }, {
              text: '365天',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
                picker.$emit('pick', date);
              }
            }, {
              text: '永久',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 36500);
                picker.$emit('pick', date);
              }
            }

          ]
        },

      };
    },
    watch: {
      state() {
        this.nowPage = 1
        this.init();
      }
    },
    async created() {
      this.showXz = await this.bykApi.global.fGetSmMenuQx('产品码库新增')
      this.showXg = await this.bykApi.global.fGetSmMenuQx('产品码库修改')
      this.showHb = await this.bykApi.global.fGetSmMenuQx('产品码库划拨')
      this.init();
    },
    methods: {
      async init(orderBy) {
        let res = await this.fProCodeManger('GET_LIST', orderBy);

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.TR = 0
        this.TP = 0
        if (res.data.length > 0) {
          this.TR = res.data[0].TR; //总条数
          this.TP = res.data[0].TP; //总页数
        }
        this.tableData = res.data;
      },

      async fModify(row) {
        this.codeMangerAddOrEdit = "修改";
        this.fileLise = []
        this.addOrEditPop = true;
        this.codeInfo = row;
        // this.codeInfo.pro_type = row.pro_type;
        // this.codeInfo.pro_code = row.pro_code;
        // this.codeInfo.stop_time = row.stop_time;
        // this.codeInfo.sale_money = row.sale_money;
        // this.codeInfo.pro_sale_money = row.pro_sale_money;
        // this.codeInfo.pro_stop_time = row.pro_stop_time;
        // this.codeInfo.add_num = row.add_num;
        // this.codeInfo.pro_code_arr = row.pro_code_arr;
        // this.codeInfo.pro_org_id = row.pro_org_id;
        // this.codeInfo.remarks = row.remarks;

      },
      async fSavecodeManger() {


        // return
        let res;
        //激活
        if (this.codeMangerAddOrEdit == '激活') {
          if (this.bykApi.smCom.fSmIsEmpty(this.codeInfo.mch_id)) {
            return this.$message("请输入商户手机号");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.codeInfo.mall_id)) {
            return this.$message("请输入门店编码");
          }
          res = await this.fProCodeManger('ACTIVE_SAAS');
        } else {

          let oper = ''
          switch (this.codeMangerAddOrEdit) {
            case '批量新增':
              oper = 'BACH_ADD'
              break
            case '批量修改':
              oper = 'BACH_EDIT'
              break
            case '修改':
              oper = 'EDIT'
              break
            case '新增':
              oper = 'ADD'
              break
            case '批量划拨':
              oper = 'BACH_CHG_ORG'
              break
          }
          if (oper != 'BACH_CHG_ORG') {
            //新增修改批量划拨
            if (this.bykApi.smCom.fSmIsEmpty(this.codeInfo.sale_money)) {
              return this.$message("请输入售卖价格");
            }
            if (this.bykApi.smCom.fSmIsEmpty(this.codeInfo.pro_sale_money)) {
              return this.$message("请输入次年续费");
            }
            if (this.bykApi.smCom.fSmIsEmpty(this.codeInfo.stop_time)) {
              return this.$message("请选择失效时间");
            }
            // if (this.bykApi.smCom.fSmIsEmpty(this.codeInfo.pro_stop_time)) {
            //   return this.$message("请选择产品到期时间");
            // }
          }
          if (oper == 'BACH_ADD') {
            if (this.bykApi.smCom.fSmIsEmpty(this.codeInfo.add_num)) {
              return this.$message("请输入生成数量");
            }
          }
          res = await this.fProCodeManger(oper);
        }
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.init();
        this.fClose();
      },
      fDel(oper,code) {
        this.$confirm('是否确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.fProCodeManger(oper,'',code);
          this.$message(res.msg)
          if (res.result != 'sucess') {
            return
          }
          this.init()
          this.fClose();
        }).catch(() => {});

      },
      fClose() {
        this.addOrEditPop = false;
        this.fileLise = []
        this.codeInfo = Object.assign({
          pro_type: 'SAAS',
          pro_code: '',
          stop_time: this.bykApi.timeHelper.manyDaysLater(365),
          sale_money: '0',
          pro_sale_money: '0',
          pro_add_day: '365',
          // pro_stop_time: this.bykApi.timeHelper.manyDaysLater(365),
          add_num: '1',
          pro_code_arr: '',
          pro_org_id: '',
          remarks: '',
          mch_id: '',
          mall_id: '',
          pro_code: '',
        });
      },
      // 排序
      fSort(e) {
        if (e.order == 'desc') {
          this.init(e.property + ' desc')
          return
        }
        this.init(e.property)
      },

      fHeadRadioChange(e) {},
      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fRegWxUser(type, item) {
        if (type == '批量修改' || type == '批量划拨' || type == '批量删除') {
          let res = this.$refs.codeMangerTable.getCheckboxRecords(true)
          if (res.length < 1) {
            return this.$message('请勾选要操作的商品')
          }
          let arr = []
          res.forEach(item => {
            arr.push(item.pro_code)
          })
          this.codeInfo.pro_code_arr = arr
          console.log(this.codeInfo.pro_code_arr)
        }
        if (type == '批量删除') {
          this.fDel('BACH_DEL')
          return
        }
        if (!this.bykApi.smCom.fSmIsEmpty(item)) {
          this.codeInfo = item;
        }
        this.codeMangerAddOrEdit = type
        this.addOrEditPop = true;
        this.fileLise = []
      },
      // 分页
      async fCurrentChange(e) {
        this.nowPage = e
        let res = await this.fProCodeManger('GET_LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },
      //获取ORG列表
      async fQuerySearchOrg(str) {
        let res = await this.fBykGetSubPartnerInfo(str)
        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }
        this.orgListSub = res.data
      },
      // ------------- 请求 开始 --------------
      async fBykGetSubPartnerInfo(searchStr) {
        // let desc = "desc";
        // let field = "last_reg_time";
        let postJson = {};
        // postJson["METHOD_NAME"] = "GET_SUB_PARTNER_INFO";
        postJson["OPER"] = 'PARTNER_LIST';
        postJson["PAGE_SIZE"] = 50;
        postJson["NOW_PAGE"] = '1';
        postJson["SEARCH_STR"] = searchStr;
        postJson["MH_YN"] = "Y"
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_PARTNER_INFO', postJson);

        return res;
      },
      async fProCodeManger(oper, orderBy,code) {
        let js = {};
        // 批量绑定或划拨给服务商 BACH_CHG_ORG BACH_CHG_PRO_ORG
        js['OPER'] = oper //'BACH_ADD'//
        js['PRO_TYPE'] = this.codeInfo.pro_type
        js['CHG_USER_NAME'] = this.bykApi.global.fGetPlatform().partnerInfo.data.user_name
        js['PRO_CODE'] = code || this.codeInfo.pro_code
        js['ORG_ID'] = '18957102098'
        if (this.codeInfo.stop_time.length > 10) {
          js['STOP_TIME'] = this.codeInfo.stop_time
        } else {
          js['STOP_TIME'] = this.codeInfo.stop_time + ' 23:59:59'
        }
        // if (this.codeInfo.pro_stop_time.length > 10) {
        //   js['PRO_STOP_TIME'] = this.codeInfo.pro_stop_time
        // } else {
        //   js['PRO_STOP_TIME'] = this.codeInfo.pro_stop_time + ' 23:59:59'
        // }
        js['SALE_MONEY'] = this.codeInfo.sale_money
        js['PRO_SALE_MONEY'] = this.codeInfo.pro_sale_money
        js['PRO_ADD_DAY'] = this.codeInfo.pro_add_day

        js['ADD_NUM'] = this.codeInfo.add_num
        js['PRO_CODE_ARR'] = this.codeInfo.pro_code_arr
        js['PRO_ORG_ID'] = this.codeInfo.pro_org_id
        js['REMARKS'] = this.codeInfo.remarks
        //查询和划拨需要登录账号ID
        if (oper == 'GET_LIST' || oper == 'BACH_CHG_ORG') {
          js['ORG_ID'] = this.bykApi.global.fGetPlatform().partnerInfo.phone
        }
        //查询参数
        js['STATE'] = this.state
        js['PAGE_SIZE'] = '50'
        js['NOW_PAGE'] = this.nowPage
        js['SEARCH_STR'] = this.merInputVal
        js['MH_YN'] = 'Y'
        js['ASC_DESC'] = orderBy
        //激活
        if (oper == 'ACTIVE_SAAS') {
          js['MCH_ID'] = this.codeInfo.mch_id
          js['STORE_ID'] = this.codeInfo.mall_id
          js['PRO_CODE_ARR'] = []
        }
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi("PRO_CODE_MANGER", js);
        console.log(res)
        return res;
      },




      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .codeManger {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 1px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: -2px;

      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }

  /* .x-w66{} */
  .must1 {
    position: relative;
  }

  .must1:after {
    position: absolute;
    top: -4px;
    right: 2px;
    content: '*';
    color: red;
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/view/codeManger.vue